import { TrackingInformation } from '../../types/global';
import type { Link } from '../../components/ui-cms-link/ui-cms-link';

export const all =
  <T>(functions: Array<(param: T) => boolean>) =>
  (param: T): boolean =>
    functions.every((f) => f(param));

export const defaultTrackingParameter: TrackingInformation = {
  events: [],
};

export const DEFAULT_TRACKING_DELAY = 200;

export const isExternalLink = (src: string): boolean => src.startsWith('http://') || src.startsWith('https://');

export const getExternalLinkAttributes = (link: Link) => ({
  externalTarget: link.src,
  customECommerceParameter: {
    4: link.src,
  },
});

export const getInternalLinkAttributes = (link: Link) => ({
  target: replaceSlashesWithDots(link),
});

export const replaceSlashesWithDots = (link: Link) => {
  const sanitizedSrc = link.src.startsWith('/') ? link.src.slice(1) : link.src;
  return sanitizedSrc.replaceAll('/', '.');
};

export const createAbsoutePathIfRelative = (possiblyRelativeUrl: string) => {
  if (possiblyRelativeUrl.startsWith('http')) {
    return possiblyRelativeUrl;
  }
  const baseUrl = window.location.href;
  return new URL(possiblyRelativeUrl, baseUrl).href;
};

export const delayPageChange = (delay: number, event: Event, linkElement: HTMLAnchorElement) => {
  if (delay) {
    event.preventDefault();
    setTimeout(() => {
      // Find the <a> element in the shadow DOM
      // eslint-disable-next-line prefer-destructuring
      const shadowRoot = linkElement.shadowRoot;
      if (shadowRoot) {
        const link = shadowRoot.querySelector('a');
        if (link) {
          const clonedLink = link.cloneNode(true) as HTMLAnchorElement;

          // Create a fake div to temporarily hold the cloned <a> element
          const fakeDiv = document.createElement('div');
          fakeDiv.appendChild(clonedLink);

          // Trigger the click on the cloned <a> element and then remove the fake div
          clonedLink.click();
          fakeDiv.remove();
        }
      }
    }, delay);
  }
};
